<template>
  <div>
    <b-button v-if="showLinkBtn" variant="primary" @click="$emit('link-action')" :disabled="isLinking">
      <i v-if="isLinking" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
      {{ requirementLineId > 0 ? 'Unlink Requirement' : 'Link Requirement' }}
    </b-button>
    <b-modal id="link-requirement-modal" ref="link-requirement-modal" size="xl" title="Link to Requirement">
      <h6>Please select a requirement to link or create a brand new requirement.</h6>
      <div class="d-flex justify-content-start align-items-end mb-2">
          <b-form-group label="Status" class="mr-2">
            <b-form-select v-model="linkFilter.statusId" @change="onSearch">
              <option :value="null">All Open</option>
              <option v-for="(status) in sortSelect(openStatuses)" :key="status.id" :value="status.id">{{status.name}}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Sales Rep" class="mr-2">
            <!-- <b-form-input v-model="filterObj.salesRep" @input="onSearch" size="sm" /> -->
            <b-form-select v-model="linkFilter.salesPersonUserId" @change="onSearch">
              <option :value="null">All</option>
              <option
                v-for="(selectRep, indexRep) in sortSelect(salesReps)"
                :key="indexRep"
                :value="selectRep.id"
              >{{ selectRep.name }}</option>
            </b-form-select>
          </b-form-group>
          <date-range-picker :dateFrom="linkFilter.dateFrom" :dateTo="linkFilter.dateTo" @handleSearch="onSearch"></date-range-picker>
          <!--<date-range-picker ref="dateRangePicker" :handleSearch="search"></date-range-picker>-->
          <div class="clear-filter-button-container">
            <b-button size="sm" @click="clearFilter">Clear filters</b-button>
          </div>
      </div>
      <grid-component
        isResizable
        isReorderable
        :gridId="linkingGridId"
        :pageable="pageable"
        :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
        :take="pageInfo.pageSize"
        :pageSizes="pageInfo.pageSize"
        :totalItems="pageInfo.totalItems"
        :itemData="linkingRequirementsData"
        :fields="requirementToLinkField"
        :handleRowClick="onRequirementClick"
        :styleCustom="'height: 160px'"
       />
       <template v-slot:modal-footer>
         <b-button variant="primary" class="mr-auto" @click="linkRequirement(0)" :disabled="isLinking"> 
           <i v-if="isLinking" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
            Create New Requirement
         </b-button>
         <b-button @click="$bvModal.hide('link-requirement-modal')">
           Cancel
         </b-button>
         <b-button :disabled="selectedToLink == 0 || isLinking" variant="primary" @click="linkRequirement(selectedToLink)">
           <i v-if="isLinking" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
           Link selected
         </b-button>
       </template>
    </b-modal>

    <grid-component
      isResizable
      isReorderable
      :canEdit="checkClaim(CAN_EDIT_REQUIREMENTS)"
      :canDelete="checkClaim(CAN_DELETE_REQUIREMENTS)"
      :gridId="gridId"
      :itemData="itemData"
      :fields="fields"
      :onEdit="openEdit"
      :onDelete="onDelete"
      :navigationField="'partNumber'"
      :styleCustom="'height: 160px'"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import debounce from 'lodash/debounce';
import requirementsFields from '@/pages/Requirements/fields';
//import DateFilters from './components/DateFilters';

import { date } from '@/shared/filters';
import { SEARCH_DEBOUNCE_TIME, GRID_ID, GRID_PAGE_SIZES } from '@/shared/constants';
import { sortChange, prepareColumnsData } from '@/shared/helpers';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import DateRangePicker from '@/shared/components/DateRangePicker/IndexNew';

export default {
  components: {
    GridSettings,
    GridComponent,
    DateRangePicker
  },
  name: 'RequirementsTabGrid',
  props: {
    companyId: {
      type: [String, Number],
      default: 0,
    },
    requirementLineId: {
      type: [String, Number],
      default: 0,
    },
    partId: {
      type: [String, Number],
      default: 0,
      },
    clearListOnPart: {
      type: Boolean,
      default: false,
      },
    partNumber: {
      type: String,
      default: null,
    },
    requirementArr: {
      type: Array,
      default: () => []
    },
    showLinkBtn: {
      type: Boolean,
      default: false
    },
    quoteLineId: [Number, String],
    salesOrderLineId: [Number, String],
    isQuoteLineView: {
      type: Boolean,
      default: false,
    },
    isSalesOrderLineView: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    checkedRowItemIdsArr: [],
    prepareColumnsData,
    fields: requirementsFields,
    pageable: {
      pageSizes: GRID_PAGE_SIZES,
    },
    date,
    gridId: GRID_ID.REQUIREMENT,
    linkingGridId: GRID_ID.REQUIREMENT_TO_LINK,
    selectedToLink: 0,
    filters: {},
    linkFilter: {
      isOpen: true,
      partId: null,
      statusId: null,
      companyId: null,
      salesPersonUserId: null,
      dateFrom: null,
      dateTo: null
    },
    openStatuses: [
      {id: 133, name: 'New'},
      {id: 134, name: 'Sent'},
      {id: 135, name: 'Sourced'},
      {id: 136, name: 'Quoted'},
    ],
    isLinking: false,
  }),
  computed: {
    /*...mapGetters('requirements', [
      'filteredRequirement',
      'currentRequirement',
      'pageInfo',
    ]),*/
    ...mapGetters('requirements', [
      'filteredRequirement',
      'pageInfo',
      'forLinkRequirements'
    ]),
    ...mapState('salesReps', ['salesReps']),
    ...mapGetters('lookup', ['crfqLineStatuses']),
    ...mapGetters('account', ['gridSettingsById']),
    itemData() {
      return this.filteredRequirement.length ? this.filteredRequirement : [];
    },
    gridSettings() {
      return this.gridSettingsById(GRID_ID.REQUIREMENT);
    },
    requirementToLinkField() {
      let field = [ ...this.fields ];
      let ndx = field.findIndex(x => x.field == 'selectcommands');

      if (ndx > -1) {
        field.splice(ndx, 1);
      }

      return field;
    },
    linkingRequirementsData() {
      return this.forLinkRequirements.map((req) => ({ ...req, selected: req.id == this.selectedToLink}))
    }
  },
  watch: {
    partId() {
      if(!this.partId && this.clearListOnPart) {
        /*this.setFilteredRequirements([]); */
        this.setItem({ resource:'filteredRequirement', payload: []});
      }
      if (this.partId != undefined) {
        this.filters.partId = this.partId;
        this.getDataFilter();
      }
    },
    requirementLineId() {
      console.log("reax");
      if (this.requirementLineId != undefined) {
        this.filters.requirementLineId = this.requirementLineId;
        this.getDataFilter();
      }
    },
    partNumber() {
      if (this.partNumber != undefined) {
        this.filters.partNumber = this.partNumber;
        this.getDataFilter();
      }
    },
    companyId() {
      if (this.companyId != undefined) {
        this.filters.companyId = this.filters.accountId = this.companyId;
        this.getDataFilter();
      }
    },
    requirementArr() {
      if (this.requirementArr.length > 0) {
        /*this.setFilteredRequirements(this.requirementArr);*/
        this.setItem({ resource:'filteredRequirement', payload: this.requirementArr});
      }
    },
    checkedRowItemIdsArr() {
      /*this.setCheckedRowItemIds(this.checkedRowItemIdsArr);*/
      this.setItem({ resource:'checkedRowItemIds', payload: this.checkedRowItemIdsArr});
    },
  },
  methods: {
    ...mapActions('requirements', [
      'getRequirementsByFilter',
      /*'selectRequirement',*/
      'deleteRequirementLine',
      'getAll',
      'addFromQuote',
      'addFromSalesOrder'
    ]),
    ...mapActions('account', ['saveGridSettings']),
    ...mapMutations('requirements', ['setItem']),
    openEdit(row) {
      this.$router.push({
        name: 'requirements.crfq',
        query: { crfqId: row.requirementId, crfqLineId: row.id, partId: row.partId },
      });
    },
    async onDelete({ id, requirementId }) {
      const deleteConfirmed = await this.openConfirmBox({message: 'Are you sure you want to delete requirement line?  This action cannot be undone.'});
      if (deleteConfirmed) {
        //await this.deleteCrfqPart(part.id);
        await this.deleteRequirementLine({ id, requirementId });
        this.getDataFilter();
      }
    },
    async getDataFilter() {
      await this.getRequirementsByFilter(this.filters);
    },
    showModal() {
      this.$bvModal.show('link-requirement-modal');
    },
    hideModal() {
      this.$bvModal.hide('link-requirement-modal');
    },
    onSearch: debounce(function(data = false) {
      this.getAll({
        listName: 'forLinkRequirements',
        filters: this.linkFilter,
        pageNumber: 1
      });
    }, SEARCH_DEBOUNCE_TIME),
    async getToLinkRequirement(filterObj) {
      this.linkFilter = { ...filterObj, statusId: null };
      
      this.setItem({ resource: 'forLinkRequirements', payload: [] })
      this.isLinking = true;
      await this.getAll({
        listName: 'forLinkRequirements',
        filters: filterObj,
        pageNumber: 1
      });
      this.isLinking = false;

      if (this.forLinkRequirements.length > 0) {
        const resp = await this.openConfirmBox({
          message: 'Would you like to link the item to a corresponding requirement?',
          okTitle: 'Yes, link to a requirement',
          cancelTitle: 'Later'
        })

        if (resp) {
          this.showModal();
        }

      } else {
        const resp = await this.openConfirmBox({
          message: 'No associated requirement for this part yet. Would you like to create a corresponding requirement now?',
          okTitle: 'Yes, create new requirement',
          cancelTitle: 'Later'
        })

        if(resp) {
          this.linkRequirement(0);
        }
      }
    },
    async linkRequirement(requirementLineId) {
      this.hideModal();
      let response = null;
      this.isLinking = true;
      
      if (this.isQuoteLineView && this.quoteLineId > 0) {
        response = await this.addFromQuote({
          requirementLineId,
          quoteLineId: this.quoteLineId
        });
      } else if (this.isSalesOrderLineView && this.salesOrderLineId > 0) {
        response = await this.addFromSalesOrder({
          requirementLineId,
          salesOrderLineId: this.salesOrderLineId
        });
      }

      if (response != null && response.status == 200) {
        this.$snotify.success('Succcessfully linked to a requirement');
        this.filters.requirementLineId = response.data.id;
        this.getDataFilter();
        this.$emit('updateLineItem');
      }
      else if (response != null && response.status != 200) {
        this.$snotify.error('There is an error for linking the requirement');
      }

      this.isLinking = false;
    },
    onRequirementClick({ dataItem }) {
      this.selectedToLink = dataItem.id;
    },
    clearFilter() {
      this.linkFilter = {
        ...this.linkFilter,
        statusId: null,
        salesPersonUserId: null,
        dateFrom: null,
        dateTo: null
      }
    }
  },
  mounted() {
    /*this.setFilteredRequirements([]);*/
    this.setItem({ resource:'filteredRequirement', payload: []});
    let goData = false;
    if (this.partId != undefined && this.partId != 0) {
      goData = true;
      this.filters.partId = this.partId;
    }
    if (this.partNumber != undefined && this.partNumber != null) {
      goData = true;
      this.filters.partNumber = this.partNumber;
    }
    if (this.requirementLineId != undefined && this.requirementLineId != 0) {
      goData = true;
      this.filters.requirementLineId = this.requirementLineId;
    }
    if (this.companyId != undefined && this.companyId != 0) {
      goData = true;
      this.filters.companyId = this.filters.accountId = this.companyId;
    }

    if (goData) {
      this.getDataFilter();
    }
  },
  beforeDestroy() {
    /*this.setCheckedRowItemIds([]);*/
    this.setItem({ resource:'checkedRowItemIds', payload: []});
  },
}
</script>
